import { Link } from "react-router-dom";
import { useSiteSettings } from "@/hooks/useSiteSettings";
import useIsAdmin from "@/hooks/useIsAdmin";

const columns = [
  {
    title: "Association",
    links: [
      { label: "L'association", to: "/association" },
      { label: "Nos réalisations", to: "/realisations" },
    ],
  },
  {
    title: "Actions",
    links: [
      { label: "Aide alimentaire", to: "/actions" },
      { label: "Soutien aux familles", to: "/actions" },
      { label: "Actions solidaires", to: "/actions" },
    ],
  },
  {
    title: "Informations",
    links: [
      { label: "Contact", to: "/contact" },
      { label: "Mentions légales", to: "/mentions-legales" },
      { label: "Politique de confidentialité", to: "/politique-de-confidentialite" },
    ],
  },
];

export default function Footer() {
  const { settings } = useSiteSettings();
  const isAdmin = useIsAdmin();

  const socials = [
    { label: "Instagram", icon: "ri-instagram-line", href: settings?.instagram || "https://www.instagram.com/humanity59_" },
    { label: "Snapchat", icon: "ri-snapchat-line", href: settings?.snapchat || "https://www.snapchat.com/@faz-humanity59" },
    { label: "WhatsApp", icon: "ri-whatsapp-line", href: settings?.whatsapp || "https://wa.me/33618232163" },
    { label: "YouTube", icon: "ri-youtube-line", href: settings?.youtube || "https://youtube.com/@humanity-59?si=-3aNepIejT2CzMCN" },
    { label: "Telegram", icon: "ri-telegram-line", href: settings?.telegram || "https://t.me/+3-x6F0OLfGg5MjM0" },
  ].filter((s) => s.href);

  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2.5 cursor-pointer">
              {settings?.logo ? (
                <>
                  <img
                    src={settings.logo}
                    alt={settings.association_name || "Logo"}
                    style={{ height: `${settings.logo_height || 40}px` }}
                    className="w-auto object-contain"
                  />
                  <span className="font-heading text-xl font-bold text-background-50">
                    {settings.association_name || "Humanity59"}
                  </span>
                </>
              ) : (
                <>
                  <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                    <i className="ri-heart-3-fill text-lg"></i>
                  </span>
                  <span className="font-heading text-xl font-bold text-background-50">
                    Humanity<span className="text-primary-400">59</span>
                  </span>
                </>
              )}
            </Link>
            <p className="mt-4 text-sm text-background-50/70 leading-relaxed">
              {settings?.description ||
                "Association humanitaire internationale. Nous agissons chaque jour pour soutenir les plus démunis grâce à la solidarité de chacun."}
            </p>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                {col.title}
              </h4>
              <ul className="space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              Réseaux sociaux
            </h4>
            <div className="flex flex-wrap gap-3">
              {socials.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  aria-label={social.label}
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors cursor-pointer"
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/60">
            © Humanity59 — Association à but non lucratif
          </p>
          <p className="text-xs text-background-50/60">
            Solidarité · Transparence · Engagement international
          </p>
          {isAdmin && (
            <Link
              to="/admin"
              className="text-xs text-background-50/40 hover:text-background-50 transition-colors cursor-pointer"
            >
              Espace admin
            </Link>
          )}
        </div>
      </div>
    </footer>
  );
}